<!-- 
    通用定位组件(参数type:资源类型（资源类型就是在五个一控制台配置图层时选择的类型）,objid:资源的对象ID)
    mode:模式:web/h5，在显示上有所区别，例如h5里面不显示zoom控件
-->
<template>
  <div class="dhmap-wrapper">
    <div id="locatemap" ref="locatemap" v-resize="resize"></div>
    <div id="marker1" title="Marker" style="height: 50px; width: 100px"></div>
    <div id="marker2" title="Marker" style="height: 50px; width: 100px"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import "ol/ol.css";
import {
  initMap,
  addLayerToMap,
  addLocateLayerToMap,
  removeAllLayersExceptBaseMap,
  actLocate,
  mapalert,
  getLayerByType,
} from "@/utils/MapUtils";
import locateStyleCollection from "@/utils/MapIcons";
import VectorSource from "ol/source/Vector.js";
import Point from "ol/geom/Point";
import Feature from "ol/Feature";
export default {
  name: "map-locator",
  components: {},
  props: {
    param: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //护林单的点值
    paramPoint: {
      type: Object,
      default: () => {
        return {
          x: "",
          y: "",
        };
      },
    },
    zqcode: {
      type: String,
      default: "",
    },
    mode: { type: String, default: "web" },
  },
  data() {
    return {
      map: null,
      gisconfig: {},
      giszqcode: "",
      type: "", //图层
      locatelFeature: null,
    };
  },
  mounted() {
    this.giszqcode = this.zqcode ? this.zqcode : this.userinfo.zqCode;
    if (this.param.gridLevel) {
      if (this.param.areaType == "zrq") {
        this.type = [
          "geo_grid_sheng",
          "geo_grid_shi",
          "geo_grid_xian",
          "geo_grid_xiang",
          "geo_grid_cun",
        ][this.param.gridLevel - 1];
      } else {
        this.type = [
          "geo_sheng",
          "geo_shi",
          "geo_xian",
          "geo_xiang",
          "geo_cun",
        ][this.param.gridLevel - 1];
      }
    }
    this.loadMap();
  },
  methods: {
    loadMap() {
      var _this = this;
      if (_this.userinfo && _this.userinfo.appId) {
        this.$api.Mapapi.getconfig({
          appId: _this.userinfo.appId,
        })
          .then((res) => {
            if (res && res.code == 1) {
              _this.gisconfig = res.data;
              //设置该地图根据CQL进行过滤加载
              _this.gisconfig.queryWithCQL = true;
              //设置CQL进行查询，必须要提供uid、uregion、uregionlevel三个参数
              _this.gisconfig.uid = _this.userinfo.uid;
              _this.gisconfig.uregion = _this.giszqcode;
              _this.gisconfig.uregionlevel = [
                null,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                5,
              ][_this.gisconfig.uregion.length];
              //初始化地图

              _this.map = initMap("locatemap", _this.gisconfig, {
                showZoom: false,
              });

              _this.map.gisConfig = res.data;
              _this.loadZrq();

              addLocateLayerToMap(_this.map);
              console.log(_this.paramPoint,"qian")
              if (_this.paramPoint && _this.paramPoint.x) {
                 console.log(_this.paramPoint.x,"里面")
                let locatelFeature = new Feature();
                locatelFeature.dhfeaturetype = "lz_protect_forest";
                locatelFeature.setGeometry(
                  new Point([
                    parseFloat(_this.paramPoint.x),
                    parseFloat(_this.paramPoint.y),
                  ])
                );

                let locatelLayer = getLayerByType(_this.map, "locatelayer");
                // console.log('locatelLayer','locatel')
                let locatelSource = locatelLayer.getSource();
                locatelSource.addFeature(locatelFeature);
                _this.map
                  .getView()
                  .setCenter([_this.paramPoint.x * 1, _this.paramPoint.y * 1]);
                _this.map.getView().setZoom(13);
              }
            } else {
              mapalert(res.msg);
            }
          })
          .catch((err) => {
            mapalert(_this.$t("task.locationType"));
          });
      }
    },
    loadZrq() {
      let _this = this;
      if (!this.map) {
        return;
      }
      removeAllLayersExceptBaseMap(this.map);
      //添加图层
      addLayerToMap(_this.map, _this.gisconfig, null, [
        "geo_sheng",
        "geo_shi",
        "geo_xian",
        "geo_xiang",
        "geo_cun",
      ]);
    },
    resize() {
      var _this = this;
      setTimeout(function () {
        _this.map.updateSize();
      }, 200);
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    param(val) {
      console.log(this.param, "map");
      let _this = this;
      if (val.gridLevel) {
        if (val.areaType == "zrq") {
          this.type = [
            "geo_grid_sheng",
            "geo_grid_shi",
            "geo_grid_xian",
            "geo_grid_xiang",
            "geo_grid_cun",
          ][val.gridLevel - 1];
        } else {
          this.type = [
            "geo_sheng",
            "geo_shi",
            "geo_xian",
            "geo_xiang",
            "geo_cun",
          ][val.gridLevel - 1];
        }
      }
      if (val.type) {
        actLocate(_this.map, _this.param.type, _this.param.objid);
      } else {
        actLocate(_this.map, _this.type, _this.param.objid);
      }
    },
    zqcode(val) {
      // this.giszqcode=val;
      this.gisconfig.uregion = val + "";
      this.gisconfig.uregionlevel = [
        null,
        1,
        1,
        2,
        2,
        3,
        3,
        4,
        4,
        4,
        5,
        5,
        5,
        5,
        5,
      ][this.gisconfig.uregion.length];
      this.loadZrq();
    },
    userinfo() {
      this.loadMap();
    },
  },
  directives: {
    // 使用局部注册指令的方式
    resize: {
      // 指令的名称
      bind(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = "",
          height = "";
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value(); // 关键
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      },
    },
  },
};
</script>

<style scoped>
#locatemap {
  width: 100%;
  height: 100%;
}
</style>
